module.exports = __webpack_public_path__ + "img/alphaton.82997b23.svg";